/**
 * Layout View for the Region
 * TODO: should now make this a SubApp
 */


require('./style.less');


var Marionette = require('marionette'),
    Backbone = require('backbone'),
    fvChannel = require('glRadio').channel('FV'),
    Util = require('../../../FV/util.js'),
    $ = require('jquery'),
    _ = require('underscore'),
    ResizeSensor = require('../../../../shim/ResizeSensorShim');


var LoginView = require('../loginView/loginView'),
    ResetView = require('../../../common/resetPlaceholder/resetPlaceholder'),
    AlertView = require('../../../common/alert/alert'),
    DocNavView = require('../nav/view');

require('jqToggleFullScreen');

/* copy anyway on build in case IE through loader */
var Grab = require('../../../../../../assets/img/grab.cur'),
    Grabbing = require('../../../../../../assets/img/grabbing.cur'),
    CSS_NAMESPACE = 'FV';


module.exports = Marionette.LayoutView.extend({
    template: require('./template.hbs'),
    initialize: function(options) {

        var fvSettings = fvChannel.request('settings');

        this.onClickCaptureHandler = null; // store a reference, needing for turning off the listener

        this.resizeSensor = null;

        if (options.el.tagName.toLowerCase() === 'body')
            $('html, body').addClass(CSS_NAMESPACE + ' fullSize-noSpacing');

        if (fvSettings.isIE) {
            this.$el.addClass('IE');
            this._applyGrabbyHandForIE();
        }

        this.$el.addClass(CSS_NAMESPACE);

        if ( fvSettings.onClick )
            this._setUpOnClickCaptureHandler( fvSettings.onClick, fvSettings.fromUrlInterface );


        this.options.vChannel.comply(this.commands, this); //TODO: mixin for the pattern


    },
    ui: {
        viewWrapper:    '.FV-view-wr'
    },
    regions: {
        content:    '.FV-viewer-doc', /* main content here: others would be overlay -- eg auth/viewer instance layout view */
        loading:    '.FV-viewer-loading',
        docNav:     '.FV-docNav-region',
        alert:      '.FV-alert-region'
    },

    // Note: the view this is called onRender the view should be in the DOM
    onRender: function() {
        this._createResizeSensor();
    },

    commands: {
        showLogin: function( unauthorizedDataModel, loginError ) {

            this.content.show( new LoginView(unauthorizedDataModel, loginError) );
            this.docNav.reset();

        },
        showLoading: function() {
            this.content.show( new ResetView() );
        },
        /**
         * TODO:
         * - now the layout view and this in there
         * - pass these in
         */
        renderDocNav: function() {

            var vCh = this.options.vChannel;
            this.docNav.show(
                new DocNavView({
                    activeDoc: vCh.request('activeDocument'),
                    docCollection: vCh.request('documents'),
                    vChannel: vCh,
                    vContainer: this.$el    //vCh.request('getWrapper') -- TODO: this is the layout
                })
            );

        },
        /**
         * TODO:
         * - can leave -- won't be option to reload unless implement -- would want new view then -- like login WR .. but this faster now
         * - could do diff view here now ...
         */
        showLoadError: function(errMsg) {

            this.$el.addClass('loginError');

            this.content.show( new AlertView( _.extend({
                    type: 'error',
                    shortMessage: 'Unable to Load Viewer'
                }, {
                    detailedMsg: errMsg
                })
            ));

        },
        'mainView.toggleMultiDocInterfaces': function(show) { /* a fwd ... */
            var v = this.docNav.currentView;
            v.toggleDocNavInterfaces.apply(v, arguments);
        },
        'mainView.toggleFullScreen': function() {

            this._detachResizeSensor();
            this.$el.toggleFullScreen( CSS_NAMESPACE );
            this._createResizeSensor();

            setTimeout( _.bind( function() {
                this.options.vChannel.command('updateAfterViewerResize');
            }, this), 1 );

        },
        'mainView.showAlert': function(viewOptions) {
            this.alert.show( new AlertView(viewOptions) );
        },
        'mainView.hideAlert': function() {
            this.alert.empty();
        }

    },

    //TODO: mixin for this pattern
    resetWiring: function() {

        var vCh = this.options.vChannel;
            vCh.comply(this.commands, this);

        vCh.reply(this.requests, this);

    },
    /*
    * Note: jQuery doesn't support event capturing
    * Need to capture!  so it's always caught -- all other events are bubbled and propagation could be stopped; these will always be captured first
    * TODO: if have more events / hooks like these, centralize in FV and forward there ...
    * */
    _setUpOnClickCaptureHandler: function( eventNameOrCallbackFn, fromUrlInterface ) {

        if (fromUrlInterface) {

            // send a postMessage with the event name
            this.onClickCaptureHandler = getDefaultUrlInterfaceClickHandler( eventNameOrCallbackFn );

        } else {

            if ( _.isFunction( eventNameOrCallbackFn ) ) {

                var viewerInstance = this.options.vChannel.request('getViewer');

                this.onClickCaptureHandler = function() {
                    return eventNameOrCallbackFn.call( FV, viewerInstance );
                };

            }

            // Could also trigger an event in this case; would be a non-breaking change in the API --
            // really no need for now; could fire off FV or dispatch a CustomEvent (DOM) probably from this.el for the caller to decide how they want to handle
        }

        this.el.addEventListener( 'click', this.onClickCaptureHandler, true );

        /*
         * Perhaps want to debounce, but that would invoke a timer and user's can't click fast anyway.
         * */
        function getDefaultUrlInterfaceClickHandler(eventName) {

            var DEFAULT_SESSION_RESET_EVENT_NAME = 'feithSessionReset';

            var message = eventName
                ? eventName
                : DEFAULT_SESSION_RESET_EVENT_NAME;

            return function() {

                if( parent != null ){
                    parent.postMessage( message ,"*" );
                }

                if( opener != null ){
                    opener.postMessage( message, "*" );
                }
            };

        }

    },

    /* create css for grab and grabbing glass used in IE; cursor urls for IE are relative the html page, not the linked css page -- why this here */
    _applyGrabbyHandForIE: function() {
        Util.createClass('.IE .grab', 'cursor: url(' + Grab + '), default');
        Util.createClass('.IE .grabbing', 'cursor: url(' + Grabbing + '), default');
    },

    /**
     * Override Backbone.View.remove to use jQuery's empty() instead of remove() on this.$el.
     * ( Called from Marionette.ItemView.destroy, which calls this.remove() -- the base of Backbone.View's remove );
     * DVBC-1550 -- this.el is that set from the user's configuration options.  We don't want to remove the
     * element they placed the viewer inside, just empty it.
     */
    remove: function() {
        this.emptyRemove();
    },

    // called from onRender and from refreshResizeSensor below
    _createResizeSensor: function() {

        var vChannel = this.options.vChannel; // can optimize ...

        this.resizeSensor = new ResizeSensor( this.ui.viewWrapper.get(0),  _.debounce( function() {
            vChannel.command('updateAfterViewerResize');
        }, 20, true));

    },
    // Note: leaving here to show this could be desired, though now not called.
    // Previously had been called from toggle full screen
    _refreshResizeSensor: function() {

        this._detachResizeSensor();
        this._createResizeSensor();
    },
    // from destroy of this view
    _detachResizeSensor: function() {
        this.resizeSensor && this.resizeSensor.detach();
    },

    /**
     * TODO: don't think mousetrap events are removed here (and maybe some more .. trying viewer.destroy)
     * Should we now destroy resize sensor ... from destroy in viewer it's current'ly called
     */
    onBeforeDestroy: function() {

        this.resizeSensor.detach();

        if ( this.resizeSensor ) {
            this._detachResizeSensor();
            this.resizeSensor = null;
        }

        this.el.removeEventListener( 'click', this.onClickCaptureHandler, true );
        this.options.vChannel.reset(); // HUH?


    },

    destroy: function() {
        Marionette.LayoutView.prototype.destroy.apply( this, arguments );
    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/views/main/view.js
 ** module id = 682
 ** module chunks = 0
 **/